<script>
import ProductOfferCell from '@components/product-offer-cell.vue'

export default {
  components: { ProductOfferCell },
  props: {
    links: {
      type: Array,
      required: true,
    },
  },
  computed: {
    nonBundleLinks() {
      // Group by retailer
      // Group the groups by bundles/non-bundles
      // Sort by retailer name
      //
      const links = this.links
      const nonBundled = links.filter((x) => x.isBundle === false)

      const toReturn = []
      for (let i = 0; i < nonBundled.length; i += 1) {
        const item = nonBundled[i]
        const matches = toReturn.filter((x) => x.uniqueId === item.uniqueId)
        if (matches.length === 0) {
          toReturn.push(item)
        } else {
          const match = toReturn[toReturn.indexOf(matches[0])]
          match.available = match.available || item.available
          if (item.available) {
            match.url = item.url
          }
          match.lastChecked = Math.max(
            parseInt(match.lastChecked),
            parseInt(item.lastChecked)
          )
          if (`${match.lastChecked}` === item.lastChecked) {
            match.url = item.url
          }
        }
      }

      toReturn.sort((a, b) => {
        return a.retailer.localeCompare(b.retailer)
      })

      return toReturn
    },
    bundleLinks() {
      // Group by retailer
      // Group the groups by bundles/non-bundles
      // Sort by retailer name
      //
      const links = this.links
      const items = links.filter((x) => x.isBundle === true)

      const toReturn = []
      for (let i = 0; i < items.length; i += 1) {
        const item = items[i]
        const matches = toReturn.filter((x) => x.uniqueId === item.uniqueId)
        if (matches.length === 0) {
          toReturn.push(item)
        } else {
          const match = toReturn[toReturn.indexOf(matches[0])]
          match.isAvailable = match.isAvailable || item.isAvailable
          if (item.isAvailable) {
            match.url = item.url
          }
          match.lastChecked = Math.max(
            parseInt(match.lastChecked),
            parseInt(item.lastChecked)
          )
          if (`${match.lastChecked}` === item.lastChecked) {
            match.url = item.url
          }
        }
      }

      toReturn.sort((a, b) => {
        return a.retailer.localeCompare(b.retailer)
      })

      return toReturn
    },
  },
}
</script>

<template>
  <div>
    <ProductOfferCell
      v-for="item in nonBundleLinks"
      :key="item.uniqueId"
      :item="item"
    >
    </ProductOfferCell>

    <v-expansion-panels
      v-if="bundleLinks.length"
      :class="$style.bundlesContainer"
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          Bundles
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ProductOfferCell
            v-for="item in bundleLinks"
            :key="item.uniqueId"
            :item="item"
          >
          </ProductOfferCell>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.bundlesContainer {
  margin-top: 50px;
}
</style>
